import { FormattedAmount } from '@/web/components/FormattedAmount/FormattedAmount';
import { TMoney, TMoneyStringOptions } from '@coverflex-tech/hypernova-utils';
import cx from 'classnames';
import css from './FormattedMoney.module.css';

export const FormattedMoney = ({
  className,
  amount,
  integer,
  options,
}: TProps) => {
  return (
    <FormattedAmount
      className={cx(css.root, className)}
      amount={amount}
      options={{ integer, symbolPosition: 'after', ...options }}
    />
  );
};

export type TProps = {
  className?: string;
  amount?: TMoney;
  integer?: boolean;
  options?: Partial<TMoneyStringOptions>;
};
